import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class RoadmapTableInitiativePlanningRoute extends Route {
  @service router;

  model() {
    return this.modelFor('backlog.initiatives.initiative');
  }
}
